import { defaultButtonPaddingObject } from '../../../defaults';
import { getPxValue } from '../../../line-height-to-px';
export function makePaddingString(_a) {
    var _b = _a.padding, top = _b.top, right = _b.right, bottom = _b.bottom, left = _b.left, _c = _a.defaultPadding, _d = _c === void 0 ? defaultButtonPaddingObject : _c, defaultTop = _d.top, defaultRight = _d.right, defaultBottom = _d.bottom, defaultLeft = _d.left;
    var hasValue = function (value) { return value !== undefined && value !== ''; };
    var resolveValue = function (primary, secondary, fallback) {
        if (hasValue(primary)) {
            return getPxValue(primary);
        }
        else if (hasValue(secondary)) {
            return getPxValue(secondary);
        }
        return getPxValue(fallback);
    };
    var resolved = [
        resolveValue(top, bottom, defaultTop),
        resolveValue(right, left, defaultRight),
        resolveValue(bottom, top, defaultBottom),
        resolveValue(left, right, defaultLeft),
    ];
    return resolved.join(' ');
}
//# sourceMappingURL=make-padding-string.js.map